export enum AudioSpriteNames {
	UI = "ui-audio",
	CUTSCENES_INTRO = "cutscenes-audio-intro",
	CUTSCENES_OUTRO_CHAPTER_1 = "cutscenes-audio-outro-chapter-1",
	CUTSCENES_OUTRO_CHAPTER_2 = "cutscenes-audio-outro-chapter-2",
	CUTSCENES_OUTRO_CHAPTER_3 = "cutscenes-audio-outro-chapter-3",
	FX1 = "fx1",
}

export enum AudioNames {
	MAIN_MUSIC = "main-music",
	INTRO_MUSIC = "intro-music",
	CITY_AMBIENT = "city-ambient",
}

export enum UIAudioNames {
	ACHIEVEMENT = "achievement",
	BUTTON_INFO = "button_info",
	BUTTON_NASTAVENIA = "button_nastavenia",
	BUTTON_OBCHOD = "button_obchod",
	BUTTON_ULOHY_DOKONCENE = "button_ulohy_dokoncene",
	BUTTON_ULOHY = "button_ulohy",
	BUTTON_UPGRADE_CLAIM = "button_upgrade_claim",
	BUTTON_UPGRADE_MAX_LVL = "button_upgrade_max_lvl",
	BUTTON_VYLEPSENIA_PRESKOCIT = "button_vylepsenia_preskocit", // settlement preskocit level
	BUTTON_VYLEPSENIA = "button_vylepsenia", // settlement
	DEMOLICIA = "demolicia",
	KLICK_GENERAL = "klick_general",
	KLICK_KOCKY_CISTENIE = "klick_kocky_cistenie",
	KLICK_KOCKY_VYCISTENE = "klick_kocky_vycistene",
	KLICK_MIMO_DOSAHU = "klick_mimo_dosahu",
	KLICK_SPAT = "klick_spat",
	NOVA_KOCKA = "nova_kocka",
	NOVA_OSADA_NAJDENA = "nova_osada_najdena",
	OSADA_PRIPOJENA = "osada_pripojena",
	OSADA_VYLEPSENIE = "osada_vylepsenie",
	PRIJEM_KLIKNUTIE_OSADY = "prijem_kliknutie_osady",
	PRIJEM_MINUTU = "prijem_minutu",
	STAVANIE_NA_VODE = "stavanie_na_vode",
	STAVANIE = "stavanie",
	ZACHRANIT_MATERIAL = "zachranit_material",
}

export enum CutscenesAudioNames {
	STEP_1 = "step_1",
	STEP_2 = "step_2",
	STEP_3 = "step_3",
	STEP_4 = "step_4",
	STEP_5 = "step_5",
	STEP_6 = "step_6",
	STEP_7 = "step_7",
	STEP_8 = "step_8",
	STEP_9 = "step_9",
	STEP_10 = "step_10",
	STEP_11 = "step_11",
	STEP_12 = "step_12",
}

export enum FX1AudioNames {
	animal_fight = "animal_fight",
	bandit_fight_oneshot = "bandit_fight_oneshot",
	general_click_new = "general_click_new",
	item_purchase = "item_purchase",
	naval_battle_oneshot = "naval_battle_oneshot",
	premium_building_construct = "premium_building_construct",
	shop_click_reward = "shop_click_reward",
	soldier_fight_oneshot = "soldier_fight_oneshot",
	upgrade_purchase = "upgrade_purchase",
	volume_click = "volume_click",
	wonder_discovery_sfx = "wonder_discovery_sfx",
}

export const AmbientSoundConfig = {
	AmbientSoundZoomLevels: {
		CLOSE: 1,
		FAR: 0.1,
	},
	AmbientSoundMaxDistance: 5,
	AmbientSoundMaxVolumePercent: 0.1,
};
